import firebase from "firebase/app"
import config from "../../firebaseConfig.js"
import "firebase/firestore"

firebase.initializeApp(config.production
  // {
  // credential: config.production,
  // databaseURL: `https://${config.production.projectId}.firebaseio.com`,
  // }
)

// Get a reference to the database service
const firestore = firebase.firestore()

// export const getAvailableContent = () => {
//   return database.ref("availableContent").get()
// }
export const getDocument = url => {
  return firestore.doc(url).get()
}

export const getBible = async (language, version) => {
  const fullBible = {};
  const bibleRef = firestore.collection(`/languages/${language}/${version}`)
  const snapshot = await bibleRef.get()
  snapshot.forEach(doc => {
    fullBible[doc.id] = doc.data();
  });
  return fullBible
}
